// extracted by mini-css-extract-plugin
export default {"tab":"burger-ingredients_tab__5eagZ","tab_hover":"burger-ingredients_tab_hover__XeJ78","title":"burger-ingredients_title__kY+3N"};